export default __webpack_public_path__ + "static/media/search.74605514.svg";